function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState, useMemo } from 'react';
import { Table, Button, Card, Row, Col, Form, OverlayTrigger, Tooltip, Tab, Tabs } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Editor } from '@tinymce/tinymce-react';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import { Loading } from '@rd-web-markets/shared/dist/util';
import ClaimStateAlerts from '@rd-web-markets/shared/dist/claim/ClaimStateAlerts';
import { StaffingCostsRow, StaffingCostsHeading, ClaimTotalsRow } from '@rd-web-markets/market/dist/financialSection/staffingCosts';
import { apiKey, getDefaultConfig } from '@rd-web-markets/shared/dist/util/tinyMceConfig';
import claimEmployeesService from '../../services/claim/claim_employees.service';
import { helpPages } from './Help';
import TeachingBubble from '@rd-web-markets/shared/dist/util/TeachingBubble';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { setLoading } from '@rd-web-markets/shared/dist/store/features/uiSlice';
import NotesList from '@rd-web-markets/shared/dist/financialSection/NotesList';
import CostFragmentsTable from '../costFragments/CostFragmentsTable';
import ReactDataGridCostFragmentsTable from '../costFragments/ReactDataGridCostFragmentsTable';
import AddNoteButton from '../AddNoteButton';
import { CheckboxFormFieldRow } from '@rd-web-markets/shared/dist/util/form';
import CostSectionRateReduction from '../costRateReductions/CostSectionRateReduction';
export const StaffingCostsSection = _ref => {
  let {
    accountType,
    claim,
    debouncedSaveClaim,
    saveClaim,
    refreshClaim,
    setClaim,
    totalPayrollCostInvalid,
    showCostFragmentsTable,
    allProjects,
    projectsLoading
  } = _ref;
  const [claimEmployees, setClaimEmployees] = useState(null);
  const claimId = useMemo(() => claim === null || claim === void 0 ? void 0 : claim.id, [claim]);
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const [activeTabKey, setActiveTabKey] = useState('cost_information');
  const handleTinyMce = content => {
    setClaim(_objectSpread(_objectSpread({}, claim), {}, {
      employee_notes: content
    }));
  };
  useEffect(() => {
    async function getData() {
      try {
        if (claimId) {
          setClaimEmployees(await claimEmployeesService.all(claimId));
        }
      } catch (error) {
        dispatch(handleError(error));
      }
    }
    getData();
  }, [dispatch, claimId]);
  if (!claim || !claimEmployees) return /*#__PURE__*/React.createElement(Loading, null);
  const hasPermissions = () => {
    return user.account_type !== 'customer' && user.account_type !== 'accountant';
  };
  const userUnauthorizedToEdit = !hasPermissions();
  const showRateReductionTabs = showCostFragmentsTable && claim.is_staffing_cost_rate_reduction_required;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimStateAlerts, {
    claim: claim
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-end align-items-center gap-2 mb-3"
  }, /*#__PURE__*/React.createElement(AddNoteButton, {
    claimId: claim.id,
    category: "staffing_costs",
    userCanEdit: hasPermissions() && !claim.financials_locked && !claim.is_locked
  }), /*#__PURE__*/React.createElement(TeachingBubble, {
    pages: helpPages,
    position: "left"
  })), showCostFragmentsTable && /*#__PURE__*/React.createElement(CheckboxFormFieldRow, {
    fieldName: 'is_staffing_cost_rate_reduction_required',
    label: 'is_rate_reduction_required',
    value: claim.is_staffing_cost_rate_reduction_required,
    onChange: e => {
      const updatedClaim = saveClaim(_objectSpread(_objectSpread({}, claim), {}, {
        is_staffing_cost_rate_reduction_required: e.target.checked
      }));
      setClaim(_objectSpread(_objectSpread({}, claim), updatedClaim));
    },
    disabled: claim.financials_locked || !hasPermissions()
  }), /*#__PURE__*/React.createElement(OverlayTrigger, {
    key: 'bottom',
    placement: 'bottom',
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      className: "tooltip-wide"
    }, "It includes total salary, national insurance contribution, and pension amount paid to directors and employees that are recognised in the total account within relevant financial year.")
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-secondary"
  }, "Company staff costs per accounts"), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    className: totalPayrollCostInvalid ? 'border-warning' : null,
    onChange: e => setClaim(_objectSpread(_objectSpread({}, claim), {}, {
      [e.target.name]: e.target.value
    })),
    onBlur: debouncedSaveClaim,
    disabled: claim.financials_locked || !hasPermissions(),
    name: "total_payroll_cost",
    object: claim,
    size: "md",
    type: "text"
  })))))), !showCostFragmentsTable && /*#__PURE__*/React.createElement(Table, {
    size: "sm",
    className: "table-scrollable-x"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(StaffingCostsHeading, null))), /*#__PURE__*/React.createElement("tbody", null, claimEmployees.map((_, index) => {
    return /*#__PURE__*/React.createElement(StaffingCostsRow, {
      key: index,
      index: index,
      claim: claim,
      claimEmployees: claimEmployees,
      setClaimEmployees: setClaimEmployees,
      refreshClaim: refreshClaim,
      claimEmployeesService: claimEmployeesService,
      ChangeHighlighter: ChangeHighlighter,
      FormattedNumberInput: FormattedNumberInput,
      handleError: handleError
    });
  }), /*#__PURE__*/React.createElement(ClaimTotalsRow, {
    ChangeHighlighter: ChangeHighlighter,
    FormattedNumberInput: FormattedNumberInput,
    claim: claim
  }))), showCostFragmentsTable && !showRateReductionTabs && /*#__PURE__*/React.createElement(ReactDataGridCostFragmentsTable, {
    claim: claim,
    refreshClaim: refreshClaim,
    costFragmentType: "UkSection::ClaimEmployee",
    userUnauthorizedToEdit: userUnauthorizedToEdit,
    allProjects: allProjects
  }), showRateReductionTabs && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mt-5"
  }), /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "cost_information",
    className: "mb-3",
    onSelect: setActiveTabKey,
    activeKey: activeTabKey
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "cost_information",
    title: "Cost Information"
  }, activeTabKey === 'cost_information' && /*#__PURE__*/React.createElement(ReactDataGridCostFragmentsTable, {
    claim: claim,
    refreshClaim: refreshClaim,
    costFragmentType: "UkSection::ClaimEmployee",
    userUnauthorizedToEdit: userUnauthorizedToEdit,
    allProjects: allProjects
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "rate_reduction",
    title: "Rate Reduction"
  }, activeTabKey === 'rate_reduction' && /*#__PURE__*/React.createElement(CostSectionRateReduction, {
    claim: claim,
    costType: 'UkSection::ClaimEmployee'
  })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-start"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "outline-primary",
    to: "/".concat(accountType, "/claims/").concat(claim.id, "/financial_details/notes_and_assumptions")
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " Back")), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-end"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "primary",
    to: "/".concat(accountType, "/claims/").concat(claim.id, "/financial_details/subcontractors")
  }, "Continue ", /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_right")))));
};